import React from "react";
import { useNavigate } from "react-router-dom";
import DeathClaimsT from "../../components/tables/deathT";
import { PlusOutlined } from "@ant-design/icons";
import img from "../../assets/images/poweredbymtn.png";

export default function Claims() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-neutral-50">
      <header className="bg-white border-b border-neutral-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h1 className="text-xl sm:text-2xl font-semibold text-neutral-900 tracking-tight">
                Track your claims
              </h1>
              <p className="mt-1 text-sm text-neutral-600">
                Request and track your insurance claims in one place.
              </p>
            </div>
            <button
              type="button"
              onClick={() => navigate("/main/claims/request")}
              className="inline-flex items-center justify-center gap-2 h-11 px-5 rounded-lg bg-[#06509E] text-white text-sm font-medium hover:bg-[#053d7a] transition-colors shrink-0"
            >
              <PlusOutlined />
              Request a claim
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-6 space-y-6">
        <div className="bg-white rounded-xl border border-neutral-200 shadow-sm overflow-hidden">
          <DeathClaimsT />
        </div>
        <div className="flex justify-center">
          <img src={img} alt="care" className="md:h-20 h-10 rounded-l-lg" />
        </div>
      </main>
    </div>
  );
}
